import {
    Box,
    Link,
    Typography
} from "@mui/material";

import { CreateLocationButton } from "./CreateLocationButton";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import React from "react";

type EmptyLocationStateProps = {
    createLocation: (locationName: string, locationImages?: Blob[]) => void | Promise<void>;
};

const userGuideLink = "https://www.teneratrack.com/_files/ugd/5dc92f_1e0333d74c0745a0bc10ed7aba98412a.pdf"

export const EmptyLocationDashboardState: React.FC<EmptyLocationStateProps> = ({
    createLocation,
}) => {
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={2}
            p={2}
        >
            <Typography>
                No locations have been created. Create your first location to begin.
            </Typography>
            {createLocation && (
                <CreateLocationButton
                    createLocation={createLocation}
                    text="Create New Location"
                    buttonProps={{ variant: "contained" }}
                />
            )}
            <Link
                href={userGuideLink}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    color: 'text.secondary',
                    textDecoration: 'none',
                    '&:hover': {
                        color: 'primary.main',
                        textDecoration: 'underline',
                    },
                }}
            >
                <HelpOutlineIcon fontSize="small" />
                <Typography variant="body2">
                    Need help? Check out our user guide
                </Typography>
            </Link>
        </Box>
    );
};